var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.4,
    height: 48,
    viewBox: "0 0 65.4 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.388 0H6.012A6.019 6.019 0 000 6.012v35.976A6.019 6.019 0 006.012 48h53.376a6.019 6.019 0 006.012-6.012V6.015A6.019 6.019 0 0059.388 0zm3.285 6.012v35.976a3.26 3.26 0 01-.34 1.453L43.001 24.109l19.4-19.4a3.267 3.267 0 01.272 1.306zm-3.285-3.285a3.277 3.277 0 01.987.152L35.686 27.567a4.222 4.222 0 01-5.971 0L5.026 2.879a3.275 3.275 0 01.986-.152zM3.049 43.404a3.264 3.264 0 01-.322-1.417V6.015a3.267 3.267 0 01.271-1.3l19.374 19.374zm2.963 1.868a3.266 3.266 0 01-.86-.115L24.3 26.01l3.486 3.486a6.957 6.957 0 009.828 0l3.459-3.459 19.132 19.132a3.291 3.291 0 01-.817.1z",
    fill: "#3d5560"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6e7458b9.svg";
export { ForwardRef as ReactComponent };